/**
 * Expand macros in string with format {%macro_format%}
 *
 * @param macroString {String}
 * @param source {Object|null}
 * @return {String|null}
 */
const expandMacros = (macroString, source = null) => {
  source = source || window;
  let string = macroString ? macroString : null;
  if (!string || !string.length || !source) {
    return string;
  }

  const macros = string.match(/{%[a-z0-9:!_-]+%}/ig);
  if (!macros) {
    return string;
  }

  for (let macro of macros) {
    var tag = macro.substr(2, macro.length - 4);
    if ("function" === typeof (source[tag])) {
      string = string.replace(macro, source[tag]());
    }

    if ("string" === typeof (source[tag])) {
      string = string.replace(macro, source[tag]);
    }
  }

  return string;
};

export default expandMacros;
